import { Button } from "@design-system/Inputs/Button";
import { FlexCol, FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { type GetObjectiveQuery } from "@generated/client/graphql";
import { useSetAtom } from "jotai";
import { type FC } from "react";
import { Trans, useTranslation } from "react-i18next";
import { isExampleDrawerOpen } from "../ExampleDrawer/ctx";
import { RESOURCE_NAME, keys } from "./i18n";
import { ObjectiveActionPlan } from "./ObjectiveActionPlan";
import { ObjectiveDescription } from "./ObjectiveDescription";

type ObjectiveBodyProps = {
    objective: GetObjectiveQuery["objective"];
};

export const ObjectiveBody: FC<ObjectiveBodyProps> = ({ objective }) => {
    const { t } = useTranslation(RESOURCE_NAME);

    const setIsExampleDrawerOpen = useSetAtom(isExampleDrawerOpen);
    const handleShowExampleClick = () => {
        setIsExampleDrawerOpen(true);
    };

    return (
        <FlexCol gap="6" px="4" pb="4">
            <FlexRow w="full" justifyContent="between" alignItems="center">
                <Text variant="header1">{t(keys.include_details)}</Text>
                <Button
                    variant="textLink"
                    size="sm"
                    onClick={handleShowExampleClick}
                >
                    {t(keys.show_example)}
                    <Button.Icon name="circleHelp" size="sm" />
                </Button>
            </FlexRow>
            <FlexCol gap="2">
                <FlexCol gap="1">
                    <Text variant="body-lg">
                        <Trans t={t} i18nKey={keys.description_title} />
                    </Text>
                    <Text color="secondary">
                        {t(keys.description_subtitle)}
                    </Text>
                </FlexCol>
                <ObjectiveDescription
                    objective={objective}
                    key={objective.id}
                />
            </FlexCol>
            <FlexCol gap="2">
                <FlexCol gap="1">
                    <Text variant="body-lg">
                        <Trans t={t} i18nKey={keys.action_plan_title} />
                    </Text>
                    <Text color="secondary">
                        {t(keys.action_plan_subtitle)}
                    </Text>
                </FlexCol>
                <ObjectiveActionPlan objective={objective} key={objective.id} />
            </FlexCol>
        </FlexCol>
    );
};
